import { API } from 'aws-amplify';
import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";

let requestInfo = {
    headers: {
        'Content-Type': 'application/json'
    }
}

export const getUserSurveyFromAPI = async (user_survey_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();
    let obj = {};
    obj["encryptedKey"] = encryptedAESKey;
    
    requestInfo["queryStringParameters"] = obj;
    
    const response = await API.get('apiAssessment', '/usersurveys/' + user_survey_id, requestInfo);
    const decryptedData = decryptResponse(response, aesKeyBase64);
    return decryptedData;
};

export const updateUserSurveyFromAPI = async (user_survey_id, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);
    requestInfo["body"] = { encryptedData, encryptedAESKey };
    
    const response = await API.put('apiAssessment', '/usersurveys/' + user_survey_id, requestInfo);
    const decryptedData = decryptResponse(response, aesKeyBase64);
    return decryptedData;
};
